"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchConfig = exports.cursorAPIContext = void 0;
exports.cursorAPIContext = {
    worklistContext: {
        query: {
            filters: [],
            pagination: {
                limit: 10,
                offset: 10
            }
        },
        resultSet: "7267e4e1-f6ad-5db2-9f6b-df88bf49920a"
    },
    servicedeskMode: true,
    workitemId: "51847b7f-0ff3-439a-8129-666c6fdf22d5",
    sessionId: "91ebf46d-1c67-41c4-91e5-b75fa54440ab",
    qaCollectionUuid: "0294dbdc-f9a6-4c70-a06a-7fe701b33b89",
    launchConfigServiceLine: "Inpatient Professional Coding"
};
exports.launchConfig = {
    worklistContext: {
        query: {
            filters: [],
            pagination: {
                limit: 10,
                offset: 10
            }
        },
        resultSet: "7267e4e1-f6ad-5db2-9f6b-df88bf49920a"
    },
    servicedeskMode: true,
    workitemId: "51847b7f-0ff3-439a-8129-666c6fdf22d5",
    sessionId: "91ebf46d-1c67-41c4-91e5-b75fa54440ab",
    serviceLine: "Inpatient Professional Coding",
    caseId: "c80e9352-37d8-4a75-ab69-e9568af357e0",
    processId: "4d158642-4895-4d19-ad73-6230fa9e1157",
    qaCollectionUuid: "0294dbdc-f9a6-4c70-a06a-7fe701b33b89"
};
//# sourceMappingURL=cursor-api.js.map